<span
  [tooltipDisabled]="
    selection | tableCollectionActionDisability: action | negate | trueOrFalse
  "
  class="inline-flex"
  pTooltip="Zaznacz elementy na liście"
  tooltipPosition="bottom">
  <p-button
    (onClick)="handleClick()"
    [disabled]="
      selection | tableCollectionActionDisability: action | trueOrFalse
    "
    [label]="action.label"
    [outlined]="true"
    appPrimengButton
    severity="secondary"
    size="small" />
</span>
